import KeyboardRenderer from "./keyboard-renderer";
import { RenderingStatus } from "./types/canvas-renderer";
const DEFAULT_CROP = [0, 0, 0, 0];
export default class BattleRenderer extends KeyboardRenderer {
    constructor() {
        super();
        this.attackOptions = [
            "ATTACK",
            "ITEM",
            "FLEE",
        ];
        this.time = 0;
    }
    reset(data) {
        var _a, _b, _c, _d, _e, _f;
        super.reset(data);
        data.menuIndex = 0;
        data.foeAttackTime = 0;
        data.foeLife = (_a = data.foeMaxLife) !== null && _a !== void 0 ? _a : 100;
        delete data.selectedIndex;
        data.battleOver = false;
        data.failedEscape = false;
        data.collected = false;
        data.message = undefined;
        data.chest = undefined;
        data.attackSequence = false;
        for (let i = 0; i < ((_d = (_c = (_b = data.persist) === null || _b === void 0 ? void 0 : _b.game.stats) === null || _c === void 0 ? void 0 : _c.heroes.length) !== null && _d !== void 0 ? _d : 0); i++) {
            if ((_f = (_e = data.persist) === null || _e === void 0 ? void 0 : _e.game.stats) === null || _f === void 0 ? void 0 : _f.heroes[i].hp) {
                data.hero = i;
                break;
            }
        }
        // data.persist?.game.stats?.heroes.forEach((stat, hero) => {
        //   if (!stat.hp) {
        //     this.saveStats(data, stat.max ?? 100, stat.max ?? 100, hero);
        //   }
        // });
        this.updateHeroName(data);
    }
    updateHeroName(data) {
        var _a;
        data.heroName = this.getHeroName((_a = data.hero) !== null && _a !== void 0 ? _a : 0);
    }
    canBattle(data, hero) {
        var _a, _b;
        const heroStat = (_b = (_a = data.persist) === null || _a === void 0 ? void 0 : _a.game.stats) === null || _b === void 0 ? void 0 : _b.heroes[hero !== null && hero !== void 0 ? hero : 0];
        return (heroStat === null || heroStat === void 0 ? void 0 : heroStat.active) && heroStat.hp;
    }
    randomHero(data) {
        var _a, _b, _c;
        const array = [];
        for (let i = 0; i < ((_c = (_b = (_a = data.persist) === null || _a === void 0 ? void 0 : _a.game.stats) === null || _b === void 0 ? void 0 : _b.heroes.length) !== null && _c !== void 0 ? _c : 0); i++) {
            if (this.canBattle(data, i)) {
                array.push(i);
            }
        }
        const index = Math.floor(Math.random() * array.length);
        return array[index];
    }
    performRendering(data, timestamp) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23;
        this.time = timestamp;
        if (this.context) {
            this.drawAnimation(data.background, timestamp, data === null || data === void 0 ? void 0 : data.startTime, true);
            if (data.foeHurtTime) {
                this.drawAnimation((_a = data.foe) === null || _a === void 0 ? void 0 : _a.hurt, timestamp, data === null || data === void 0 ? void 0 : data.startTime, true);
                if (timestamp - data.foeHurtTime > 1000) {
                    data.foeHurtTime = 0;
                    if (!data.foeLife) {
                        data.chest = {
                            opened: 0,
                        };
                        (_c = (_b = data.persist) === null || _b === void 0 ? void 0 : _b.game.stats) === null || _c === void 0 ? void 0 : _c.heroes.filter(({ active, hp }) => active && hp).forEach((heroStat, hero) => { var _a; return this.addXP(data, (_a = data.xp) !== null && _a !== void 0 ? _a : 0, hero); });
                        let extraMessage = "";
                        (_e = (_d = data.persist) === null || _d === void 0 ? void 0 : _d.game.stats) === null || _e === void 0 ? void 0 : _e.heroes.filter(({ active, hp }) => active && hp).forEach((heroStat, hero) => {
                            extraMessage += this.updateStatsWithLevelProgression(data, hero) ? ` ${this.getHeroName(hero)} advanced a new level.` : '';
                        });
                        this.updateLevelProgression(data);
                        data.message = `The ${(_f = data.foe) === null || _f === void 0 ? void 0 : _f.name} has been defeated.You gained ${data.xp} XP.` + extraMessage;
                        data.battleOver = true;
                    }
                }
            }
            else if (!data.foeLife) {
                //  hide
            }
            else if (data.foeAttackTime) {
                const { animating } = this.drawAnimation((_g = data.foe) === null || _g === void 0 ? void 0 : _g.attack, timestamp, data.foeAttackTime, false);
                if (!animating) {
                    data.foeAttackTime = 0;
                    data.waitTime = timestamp;
                    data.attackSequence = false;
                    if (Math.random() < this.getDodgeChance(data) && !data.failedEscape) {
                        data.foeMissed = true;
                        // console.log("FOE MISSED");
                        this.playSFX((_h = data.sounds) === null || _h === void 0 ? void 0 : _h.miss);
                        for (let i = 0; i < ((_l = (_k = (_j = data.persist) === null || _j === void 0 ? void 0 : _j.game.stats) === null || _k === void 0 ? void 0 : _k.heroes.length) !== null && _l !== void 0 ? _l : 0); i++) {
                            if ((_o = (_m = data.persist) === null || _m === void 0 ? void 0 : _m.game.stats) === null || _o === void 0 ? void 0 : _o.heroes[i].hp) {
                                data.hero = i;
                                break;
                            }
                        }
                        this.updateHeroName(data);
                    }
                    else {
                        data.hurtTime = timestamp;
                        data.failedEscape = false;
                        // console.log("FOE HIT", data.heroName);
                        const damage = 1 + (((_p = data.foeStrength) !== null && _p !== void 0 ? _p : 10) * Math.random() * 2 * this.getDefense(data, (_q = data.hero) !== null && _q !== void 0 ? _q : 0));
                        const heroStat = this.getHeroStat(data, (_r = data.hero) !== null && _r !== void 0 ? _r : 0);
                        const hp = Math.max(0, (_s = heroStat.hp) !== null && _s !== void 0 ? _s : 0) - Math.floor(damage);
                        this.saveStats(data, hp, (_t = heroStat.max) !== null && _t !== void 0 ? _t : 0, (_u = data.hero) !== null && _u !== void 0 ? _u : 0);
                        this.playSFX((_v = data.sounds) === null || _v === void 0 ? void 0 : _v.foeHit);
                    }
                }
            }
            else {
                this.drawAnimation((_w = data.foe) === null || _w === void 0 ? void 0 : _w.idle, timestamp, data === null || data === void 0 ? void 0 : data.startTime, false);
            }
            if (data.attackTime) {
                const { animating } = this.drawAnimation(data.strike, timestamp, (_x = data.attackTime) !== null && _x !== void 0 ? _x : 0, false);
                if (!animating) {
                    data.attackTime = 0;
                }
                if (timestamp - data.attackTime > 100 && !data.missed && !data.foeHurtTime) {
                    if (Math.random() < .3 || !this.getAttack(data, (_y = data.hero) !== null && _y !== void 0 ? _y : 0)) {
                        // console.log("MISSED");
                        data.missed = true;
                        this.playSFX((_z = data.sounds) === null || _z === void 0 ? void 0 : _z.miss);
                    }
                    else {
                        // console.log("HIT");
                        data.foeLife = Math.max(0, ((_0 = data.foeLife) !== null && _0 !== void 0 ? _0 : 0) - Math.floor(1 + this.getAttack(data, (_1 = data.hero) !== null && _1 !== void 0 ? _1 : 0) * Math.random() * 2));
                        data.foeHurtTime = timestamp;
                        this.playSFX((_2 = data.sounds) === null || _2 === void 0 ? void 0 : _2.playerHit);
                        if (!data.foeLife) {
                            this.changeMusic(undefined);
                        }
                    }
                }
            }
            if (data.chest) {
                if (data.chest.opened) {
                    const { animating } = this.drawAnimation(data.chestOpen, timestamp, data.chest.opened, false);
                    if (!animating && !data.message && !data.collected) {
                        data.collected = true;
                        data.justPickedUp = true;
                        data.message = `The chest contains ${data.gold} gold.`;
                        this.addGold(data, (_3 = data.gold) !== null && _3 !== void 0 ? _3 : 0);
                    }
                }
                else {
                    this.drawAnimation(data.chestClose, timestamp, 0, false);
                }
                if (!data.chest.opened && !data.message) {
                    data.chest.opened = timestamp;
                    this.playSFX((_4 = data.sounds) === null || _4 === void 0 ? void 0 : _4.door);
                }
            }
            if (data.hurtTime) {
                this.drawAnimation(data.hurt, timestamp, (_5 = data.hurtTime) !== null && _5 !== void 0 ? _5 : 0, true);
                if (timestamp - data.hurtTime > 1000) {
                    data.hurtTime = 0;
                    for (let i = 0; i < ((_8 = (_7 = (_6 = data.persist) === null || _6 === void 0 ? void 0 : _6.game.stats) === null || _7 === void 0 ? void 0 : _7.heroes.length) !== null && _8 !== void 0 ? _8 : 0); i++) {
                        if ((_10 = (_9 = data.persist) === null || _9 === void 0 ? void 0 : _9.game.stats) === null || _10 === void 0 ? void 0 : _10.heroes[i].hp) {
                            data.hero = i;
                            break;
                        }
                    }
                    this.updateHeroName(data);
                }
            }
            if (data.attackSequence && !data.message) {
                if (!data.attackTime && !data.foeHurtTime && !data.foeAttackTime) {
                    //  Done attacking.
                    if (((_11 = data.hero) !== null && _11 !== void 0 ? _11 : 0) < ((_14 = (_13 = (_12 = data.persist) === null || _12 === void 0 ? void 0 : _12.game.stats) === null || _13 === void 0 ? void 0 : _13.heroes.length) !== null && _14 !== void 0 ? _14 : 0) - 1 && !data.failedEscape) {
                        //  next attacking hero
                        data.hero = ((_15 = data.hero) !== null && _15 !== void 0 ? _15 : 0) + 1;
                        this.updateHeroName(data);
                        if (this.canBattle(data, data.hero)) {
                            data.attackSequence = false;
                        }
                    }
                    else {
                        //  Foe attack
                        data.hero = this.randomHero(data);
                        this.updateHeroName(data);
                        data.foeAttackTime = timestamp;
                    }
                }
            }
            if (data.waitTime && timestamp - ((_16 = data.waitTime) !== null && _16 !== void 0 ? _16 : 0) > 300) {
                data.waitTime = 0;
            }
            if (data.dialog) {
                data.dialog.hidden = ((_17 = data.foeAttackTime) !== null && _17 !== void 0 ? _17 : 0) > 0
                    || ((_18 = data.attackTime) !== null && _18 !== void 0 ? _18 : 0) > 0
                    || ((_19 = data.hurtTime) !== null && _19 !== void 0 ? _19 : 0) > 0
                    || ((_20 = data.foeHurtTime) !== null && _20 !== void 0 ? _20 : 0) > 0
                    || ((_21 = data.waitTime) !== null && _21 !== void 0 ? _21 : 0) > 0
                    || data.battleOver
                    || !!data.message;
            }
            if (((_23 = (_22 = data.persist) === null || _22 === void 0 ? void 0 : _22.game.stats) === null || _23 === void 0 ? void 0 : _23.heroes.every(({ hp }) => !hp)) && !data.hurtTime && !data.battleOver && data.dialog) {
                data.battleOver = true;
                data.message = "You have died.";
                data.dialog.hidden = true;
                data.mute = true;
            }
        }
        return data.message || !data.battleOver || (data.chest && !data.collected) ? RenderingStatus.RENDERING : RenderingStatus.COMPLETED;
    }
    getDodgeChance(data) {
        var _a, _b;
        if ((_b = (_a = data.persist) === null || _a === void 0 ? void 0 : _a.game.inventory) === null || _b === void 0 ? void 0 : _b["shield"]) {
            return .4;
        }
        return .3;
    }
    hasCloak(data) {
        var _a;
        return ((_a = data.inventory) !== null && _a !== void 0 ? _a : []).indexOf("cloak") >= 0;
    }
    createKeyHandlerDown(data) {
        const numOptions = data.subMenu && data.inventory ? data.inventory.length : this.attackOptions.length;
        return (e) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            e.preventDefault();
            if ((_a = data.dialog) === null || _a === void 0 ? void 0 : _a.hidden) {
                return;
            }
            switch (e.code) {
                case "KeyA":
                case "ArrowLeft":
                    data.menuIndex = (((_b = data.menuIndex) !== null && _b !== void 0 ? _b : 0) - 1 + numOptions) % numOptions;
                    break;
                case "KeyD":
                case "ArrowRight":
                    data.menuIndex = (((_c = data.menuIndex) !== null && _c !== void 0 ? _c : 0) + 1 + numOptions) % numOptions;
                    break;
                case "Space":
                    data.selectedIndex = data.menuIndex;
                    data.menuIndex = 0;
                    if (data.subMenu) {
                        if (data.selectedIndex === 0) {
                            const item = (_d = data.inventory) === null || _d === void 0 ? void 0 : _d[0];
                            if (item) {
                                this.removeItem(data, item);
                                this.performAction(data, (_e = data.itemActions) === null || _e === void 0 ? void 0 : _e[item]);
                                this.playSFX((_f = data.sounds) === null || _f === void 0 ? void 0 : _f.pickup);
                                if (data.dialog) {
                                    data.dialog.hidden = true;
                                    data.attackSequence = true;
                                    data.missed = true;
                                }
                            }
                        }
                        else if (data.selectedIndex === 1) {
                            const item = (_g = data.inventory) === null || _g === void 0 ? void 0 : _g[1];
                            if (item) {
                                this.removeItem(data, item);
                                this.performAction(data, (_h = data.itemActions) === null || _h === void 0 ? void 0 : _h[item]);
                                this.playSFX((_j = data.sounds) === null || _j === void 0 ? void 0 : _j.pickup);
                                if (data.dialog) {
                                    data.dialog.hidden = true;
                                    data.attackSequence = true;
                                    data.missed = true;
                                }
                            }
                        }
                        delete data.subMenu;
                    }
                    else {
                        if (data.selectedIndex === 0) {
                            data.attackTime = this.time;
                            data.attackSequence = true;
                            data.foeHurtTime = 0;
                            data.missed = false;
                            data.hurtTime = 0;
                            data.foeMissed = false;
                            data.failedEscape = false;
                        }
                        else if (data.selectedIndex === 1) {
                            data.subMenu = true;
                            delete data.selectedIndex;
                        }
                        else if (data.selectedIndex === 2) {
                            if (Math.random() < .3 * (this.hasCloak(data) ? .5 : 1)) {
                                data.message = "Your escape attempt has FAILED.";
                                if (data.dialog) {
                                    data.dialog.hidden = true;
                                    data.attackSequence = true;
                                    data.missed = true;
                                    data.failedEscape = true;
                                }
                            }
                            else {
                                data.message = "You have escaped.";
                                data.battleOver = true;
                                if (data.dialog) {
                                    data.dialog.hidden = true;
                                }
                            }
                        }
                    }
                    break;
            }
        };
    }
}
